import React, { createContext, useState, useEffect } from 'react';
import Cookies from 'js-cookie';

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(Cookies.get('theme') || 'light');

  useEffect(() => {
    Cookies.set('theme', theme, { expires: 30 }); // The cookie will expire in 30 days
    if (theme === 'dark') {
      loadDarkTheme();
    } else {
      loadLightTheme();
    }
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  const loadLightTheme = () => {
    const lightThemeLink = document.getElementById('light-theme');
    const darkThemeLink = document.getElementById('dark-theme');
    if (darkThemeLink) {
      darkThemeLink.disabled = true;
    }
    if (lightThemeLink) {
      lightThemeLink.disabled = false;
    }
  };

  const loadDarkTheme = () => {
    const lightThemeLink = document.getElementById('light-theme');
    const darkThemeLink = document.getElementById('dark-theme');
    if (lightThemeLink) {
      lightThemeLink.disabled = true;
    }
    if (darkThemeLink) {
      darkThemeLink.disabled = false;
    }
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
